import React, { useState, useEffect } from "react";
import Api from "utils/api";
import moment from "moment";
import styled from "styled-components";
import { Icon } from "@evertrue/et-components";

export const LastUpdate = styled.div`
  color: white;
  padding: 16px 20px 0 20px;
  font-size: 14px;
`;

export const LastUpdateText = styled.span`
  margin-left: 8px;
  font-weight: 500;
`;

export const LastUpdateDate = styled.p`
  font-weight: 400;
  margin-left: 26px;
  margin-top: 8px;
`;

const ApiStatus = () => {
  const [lastUpdate, setLastUpdate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLatestData = async () => {
      setLoading(true);

      try {
        const response = await Api.IMPORT.LATEST.get();

        // INT-1596: a brand-new org has no completed jobs yet. The importer now returns an empty
        // object (200) instead of a 404, so status_started_at may be absent. Guard against it so
        // we don't format an undefined timestamp into "Invalid date".
        const startedAt =
          response && response.data && response.data.status_started_at;
        setLastUpdate(startedAt || null);
      } catch (err) {
        console.log("Failed to fetch latest import status:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestData();
  }, []);

  const date = loading
    ? "Unavailable"
    : lastUpdate
      ? moment(lastUpdate).format("MM/DD/YYYY @ h:mm A")
      : "No data imported yet";

  return (
    <LastUpdate>
      <Icon icon="access-time" />
      <LastUpdateText>Last Data Update</LastUpdateText>
      <LastUpdateDate>{date}</LastUpdateDate>
    </LastUpdate>
  );
};

export default ApiStatus;
